import React, { useState } from "react";
import { Button, Card, Form, Input, Typography, Row, Col } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import UploadMany from "@/components/Card/UploadMany";
import {
  addDesignation,
  loadAllDesignation,
} from "@/redux/rtk/features/hrm/designation/designationSlice";

const { Title, Text } = Typography;

const AddDesignation = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (loading) return;
    setLoading(true);
    try {
      const resp = await dispatch(addDesignation(values));
      if (resp?.payload?.message === "success") {
        toast.dismiss();
        toast.success("Designation created successfully!");
        form.resetFields();
        dispatch(loadAllDesignation({ page: 1, count: 10, status: true }));
      } else {
        toast.dismiss();
        toast.error("Failed to create designation");
      }
    } catch {
      toast.dismiss();
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Header */}
      <div className="text-center mb-6 px-2">
        <Title level={3} style={{ marginBottom: 4 }}>
          Create New Designation
        </Title>
        <Text type="secondary">
          Add a new job designation to your HRM system.
        </Text>
      </div>

      {/* Form */}
      <Form
        form={form}
        layout="vertical"
        name="add-designation"
        onFinish={handleSubmit}
        autoComplete="off"
        requiredMark={false}
        className="px-2 sm:px-6"
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={18} md={16}>
            <Form.Item
              label="Designation Name"
              name="name"
              rules={[{ required: true, message: "Please enter a designation name!" }]}
            >
              <Input
                placeholder="e.g. Sales Executive, HR Manager"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Submit: full width on mobile, right-aligned on larger screens */}
        <div className="mt-2 flex justify-end">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            className="w-full sm:w-auto"
          >
            <span className="flex items-center gap-2 justify-center">
              <SaveOutlined />
              Create Designation
            </span>
          </Button>
        </div>
      </Form>

      {/* CSV Import Section */}
      <Card
        className="mt-6 sm:mt-8 mx-2 sm:mx-6"
        style={{ borderRadius: 12 }}
        title={<span className="font-semibold">Import from CSV</span>}
      >
        <UploadMany
          title="Demo Designation"
          demoData={[["name"], ["Manager"], ["Salesman"], ["Employee"]]}
          urlPath="designation"
          loadAllThunk={loadAllDesignation}
          query={{ page: 1, count: 10, status: true }}
        />
      </Card>
    </>
  );
};

export default AddDesignation;
